export type FreebuildToolRoute = "demo" | "assets" | "editor" | "outfit";

export function readFreebuildToolRoute(location: Location): FreebuildToolRoute {
  const params = new URLSearchParams(location.search);
  const mode = params.get("mode")?.toLowerCase();
  if (mode === "assets" || mode === "asset-explorer" || mode === "asset") {
    return "assets";
  }
  if (mode === "editor" || mode === "world-editor" || mode === "builder") {
    return "editor";
  }
  if (mode === "outfit" || mode === "outfits" || mode === "character-outfit-builder") {
    return "outfit";
  }

  const hash = location.hash.replace(/^#/, "").toLowerCase();
  if (hash === "assets" || hash === "asset-explorer") {
    return "assets";
  }
  if (hash === "editor" || hash === "world-editor" || hash === "builder") {
    return "editor";
  }
  if (hash === "outfit" || hash === "outfits" || hash === "character-outfit-builder") {
    return "outfit";
  }

  const path = location.pathname.toLowerCase();
  if (path.includes("tasteewheat-freebuild-assets") || path.endsWith("/assets/")) {
    return "assets";
  }
  if (path.includes("tasteewheat-freebuild-editor") || path.endsWith("/editor/")) {
    return "editor";
  }
  if (path.includes("tasteewheat-freebuild-outfit") || path.endsWith("/outfit/")) {
    return "outfit";
  }

  return "demo";
}
